(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('grama-collection-rail')) {
    customElements.define('grama-collection-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        if (!this.track || this.abort) return;
        this.navigation = this.querySelector('[data-rail-navigation]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        this.progress = this.querySelector('[data-rail-progress]');
        this.progressBar = this.querySelector('[data-rail-progress-bar]');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.scheduleUpdate());
        this.observer.observe(this.track);
        this.observer.observe(this.querySelector('.grama-rail__list'));
        this.scheduleUpdate();
      }
      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }
      update() {
        const items = this.track.querySelectorAll('.grama-rail__item');
        if (!items.length) return;
        const overflow = this.track.scrollWidth - this.track.clientWidth > 2;
        if (this.navigation) this.navigation.hidden = !overflow;
        if (this.progress) this.progress.hidden = !overflow;
        this.track.tabIndex = overflow ? 0 : -1;
        const viewport = this.track.getBoundingClientRect();
        const first = items[0].getBoundingClientRect();
        const last = items[items.length - 1].getBoundingClientRect();
        const gutter = parseFloat(getComputedStyle(this).getPropertyValue('--rail-gutter')) || 0;
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        if (this.previous) this.previous.disabled = !overflow || (this.rtl ? first.right <= viewport.right - gutter + 2 : first.left >= viewport.left + gutter - 2);
        if (this.next) this.next.disabled = !overflow || (this.rtl ? last.left >= viewport.left + gutter - 2 : last.right <= viewport.right - gutter + 2);
        if (this.progressBar) {
          const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
          const trackWidth = this.progress.clientWidth;
          const thumbWidth = Math.max(trackWidth * (this.track.clientWidth / this.track.scrollWidth), 18);
          const scrollLeft = this.track.scrollLeft;
          const ratio = maxScroll > 0 ? scrollLeft / maxScroll : 0;
          const maxTranslate = trackWidth - thumbWidth;
          this.progressBar.style.width = `${thumbWidth}px`;
          this.progressBar.style.transform = `translateX(${maxTranslate * ratio}px)`;
        }
      }
      move(direction) {
        const item = this.track.querySelector('.grama-rail__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.querySelector('.grama-rail__list')).columnGap) || parseFloat(getComputedStyle(this.querySelector('.grama-rail__list')).gap) || 0;
        const step = item.getBoundingClientRect().width + gap;
        this.track.scrollBy({
          left: direction * step * (this.rtl ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('grama-help-page')) return;
    class GramaHelpPage extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') {
          if (this.hashHandler) window.addEventListener('hashchange', this.hashHandler);
          return;
        }
        const content = this.querySelector('[data-help-content]');
        if (!content) return;
        const faqMode = this.dataset.faqMode === 'true';
        const nodes = Array.from(content.childNodes);
        const groups = [];
        const leadingNodes = [];
        let currentGroup = null;
        // Use childNodes, not children: preserve text, comments and all markup.
        nodes.forEach((node) => {
          if (node.nodeName === 'H2') {
            currentGroup = { heading: node, nodes: [] };
            groups.push(currentGroup);
          } else if (currentGroup) {
            currentGroup.nodes.push(node);
          } else {
            leadingNodes.push(node);
          }
        });
        const fragment = document.createDocumentFragment();
        const appendNodes = (parent, items) => items.forEach((node) => parent.appendChild(node));
        const hasContent = (items) => items.some((node) =>
          node.nodeType === Node.ELEMENT_NODE ||
          (node.nodeType === Node.TEXT_NODE && node.textContent.trim())
        );
        const appendQuestions = (parent, items) => {
          let question = null;
          let answer = [];
          const flush = () => {
            if (!question) return;
            // An unanswered heading remains visible instead of becoming an empty toggle.
            if (!hasContent(answer)) {
              parent.appendChild(question);
              appendNodes(parent, answer);
            } else {
              const details = document.createElement('details');
              details.className = 'help-page__accordion';
              const summary = document.createElement('summary');
              summary.className = 'help-page__accordion-summary';
              question.classList.add('help-page__question');
              summary.appendChild(question);
              const icon = document.createElement('span');
              icon.className = 'help-page__accordion-icon';
              icon.setAttribute('aria-hidden', 'true');
              summary.appendChild(icon);
              const body = document.createElement('div');
              body.className = 'help-page__accordion-body help-page__prose';
              appendNodes(body, answer);
              details.append(summary, body);
              parent.appendChild(details);
            }
            question = null;
            answer = [];
          };
          items.forEach((node) => {
            if (node.nodeName === 'H3') {
              flush();
              question = node;
            } else if (question) {
              answer.push(node);
            } else {
              parent.appendChild(node);
            }
          });
          flush();
        };
        if (hasContent(leadingNodes)) {
          const introduction = document.createElement('div');
          introduction.className = 'help-page__leading help-page__prose';
          if (faqMode) appendQuestions(introduction, leadingNodes);
          else appendNodes(introduction, leadingNodes);
          fragment.appendChild(introduction);
        } else {
          appendNodes(fragment, leadingNodes);
        }
        groups.forEach((group, index) => {
          const panel = document.createElement('section');
          panel.className = faqMode ? 'help-page__faq-section' : 'help-page__info-card';
          group.heading.classList.add('help-page__section-title');
          if (faqMode) {
            panel.appendChild(group.heading);
            const questions = document.createElement('div');
            questions.className = 'help-page__questions help-page__prose';
            appendQuestions(questions, group.nodes);
            panel.appendChild(questions);
          } else {
            const top = document.createElement('div');
            top.className = 'help-page__info-top';
            const number = document.createElement('span');
            number.className = 'help-page__info-number';
            number.setAttribute('aria-hidden', 'true');
            number.textContent = String(index + 1).padStart(2, '0');
            top.append(number, group.heading);
            const body = document.createElement('div');
            body.className = 'help-page__info-body help-page__prose';
            appendNodes(body, group.nodes);
            panel.append(top, body);
          }
          fragment.appendChild(panel);
        });
        content.replaceChildren(fragment);
        content.classList.add('help-page__content--enhanced');
        // Make wide size charts scroll inside the page instead of stretching it.
        content.querySelectorAll('table').forEach((table, index) => {
          if (table.parentElement.classList.contains('help-page__table-scroll')) return;
          const wrapper = document.createElement('div');
          wrapper.className = 'help-page__table-scroll';
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          wrapper.setAttribute('aria-label',
            table.caption?.textContent.trim() || `Tabla ${index + 1}. Desplázate para ver todas las columnas.`
          );
          table.before(wrapper);
          wrapper.appendChild(table);
        });
        // Preserve links to headings inside a collapsed answer.
        const revealHash = () => {
          if (!window.location.hash) return;
          let id;
          try { id = decodeURIComponent(window.location.hash.slice(1)); }
          catch { return; }
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          let parent = target;
          while (parent && parent !== this) {
            if (parent.nodeName === 'DETAILS') parent.open = true;
            parent = parent.parentElement;
          }
          target.scrollIntoView({ block: 'start' });
        };
        this.hashHandler = revealHash;
        window.addEventListener('hashchange', this.hashHandler);
        this.dataset.initialized = 'true';
        revealHash();
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this.hashHandler);
      }
    }
    // Custom elements initialize every instance, including Theme Editor replacements.
    customElements.define('grama-help-page', GramaHelpPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('grama-product-recommendations')) {

    customElements.define('grama-product-recommendations', class extends HTMLElement {

      connectedCallback() {

        if (this.initialized) return;

        this.initialized = true;

        this.abort = new AbortController();

        if (this.querySelector('[data-related-content]')) {

          this.setupCarousel();

          return;

        }

        if (!this.dataset.recommendationsUrl) return;

        if ('IntersectionObserver' in window) {

          this.intersectionObserver = new IntersectionObserver(entries => {

            if (!entries.some(entry => entry.isIntersecting)) return;

            this.intersectionObserver.disconnect();

            this.load();

          }, { rootMargin: '500px 0px' });

          this.intersectionObserver.observe(this);

        } else {

          this.load();

        }

      }

      async load() {

        try {

          const response = await fetch(this.dataset.recommendationsUrl, {

            credentials: 'same-origin',

            signal: this.abort.signal

          });

          if (!response.ok) throw new Error(`Related products request failed (${response.status})`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');

          const remote = [...html.querySelectorAll('grama-product-recommendations')]

            .find(element => element.dataset.relatedSectionId === this.dataset.relatedSectionId);

          const content = remote?.querySelector('[data-related-content]');

          if (!content?.querySelector('.gr-related__item')) return;

          this.replaceChildren(document.importNode(content, true));

          this.classList.add('is-loaded');

          this.setupCarousel();

        } catch (error) {

          if (error.name !== 'AbortError') console.error('Grama related recommendations:', error);

        }

      }

      setupCarousel() {

        this.track = this.querySelector('[data-related-track]');

        this.controls = this.querySelector('[data-related-controls]');

        this.prev = this.querySelector('[data-related-prev]');

        this.next = this.querySelector('[data-related-next]');

        if (!this.track || !this.controls || !this.prev || !this.next) return;

        this.prev.addEventListener('click', () => this.move(-1), { signal: this.abort.signal });

        this.next.addEventListener('click', () => this.move(1), { signal: this.abort.signal });

        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true, signal: this.abort.signal });

        if ('ResizeObserver' in window) {

          this.resizeObserver = new ResizeObserver(() => this.updateControls());

          this.resizeObserver.observe(this.track);

        } else {

          window.addEventListener('resize', () => this.updateControls(), { signal: this.abort.signal });

        }

        this.updateControls();

      }

      updateControls() {

        if (!this.track) return;

        const max = this.track.scrollWidth - this.track.clientWidth;

        const scroll = this.track.scrollLeft;

        this.controls.hidden = max <= 2;

        this.prev.disabled = scroll <= 2;

        this.next.disabled = scroll >= max - 2;

        this.track.tabIndex = max > 2 ? 0 : -1;

      }

      move(direction) {

        const first = this.track.querySelector('.gr-related__item');

        if (!first) return;

        const list = this.track.querySelector('.gr-related__list');

        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;

        this.track.scrollBy({ left: direction * (first.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });

      }

      disconnectedCallback() {

        this.intersectionObserver?.disconnect();

        this.resizeObserver?.disconnect();

        this.abort?.abort();

        this.initialized = false;

      }

    });

  }


  } catch(e) { console.error(e); }
})();
})();
